/**
 * Formats a phone number to US format: (XXX) XXX-XXXX
 * Removes all non-numeric characters and applies the mask
 *
 * @param value - The phone number string to format
 * @returns The formatted phone number or empty string if input is invalid

 */
export const formatPhoneNumber = (value: string): string => {
  if (!value) return '';

  // Remove all non-numeric characters
  const cleaned = value.replace(/\D/g, '');

  const limited = cleaned.substring(0, 10);

  // Apply formatting based on length
  if (limited.length === 0) {
    return '';
  } else if (limited.length <= 3) {
    return `(${limited}`;
  } else if (limited.length <= 6) {
    return `(${limited.slice(0, 3)}) ${limited.slice(3)}`;
  } else {
    return `(${limited.slice(0, 3)}) ${limited.slice(3, 6)}-${limited.slice(6)}`;
  }
};

/**
 * Removes phone number formatting, keeping only digits
 * Useful for storing the raw value
 *
 * @param value - The formatted phone number string
 * @returns The unformatted phone number (digits only)
 */
export const unformatPhoneNumber = (value: string): string => {
  if (!value) return '';
  return value.replace(/\D/g, '');
};
